import DrawerContent from "./drawerContent";
import {NavbarDrawer} from "./styles";
import React from "react";

interface Props {
  open: boolean;
  onClose: (event: React.KeyboardEvent | React.MouseEvent) => void;
}

export default function StyledDrawer({open, onClose}: Props) {
  return (
    <NavbarDrawer
      variant="temporary"
      anchor="left"
      open={open}
      onClose={onClose}
      ModalProps={{keepMounted: true}}
    >
      <DrawerContent onInteraction={onClose} />
    </NavbarDrawer>
  );
}
